import { BlogAuthorDto } from '@/components/BlogPage/types';
import { extractPlainTextFromBlocksContent } from '@/lib/blocks-content';

export const resolveFromPostLabel = (author: BlogAuthorDto, fromPostUrl: string) => {
	const relatedPost = [...(author.blogPosts ?? []), ...(author.blogPostsExpertise ?? [])].find(
		post => post.seo?.url === fromPostUrl
	);

	if (!relatedPost) return fromPostUrl;

	return extractPlainTextFromBlocksContent(relatedPost.title) || fromPostUrl;
};
